import type React from "react";
import { ReactComponent as Svg } from "./assets/navigation-menu.svg";
import * as styles from "./Icon.module.scss";

type HamburgerProps = React.SVGProps<SVGSVGElement>;

export const Hamburger = ({ className, ...props }: HamburgerProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
